import React,  { useState, useEffect }  from "react";
import AttestationStatusComp from "./AttestationStatusComp";


const AttestationListComp = (props)=>{

    const [listFrame, setListFrame] = useState([]);

    useEffect(() => {
        var index = listFrame.length;
        setListFrame(p => p.concat(props.items.slice(index, props.dataFrame.limit)));
    }, [props.dataFrame.limit]);

    return(
        <ul className="flex-table">
            <li className="table-row table-header">
                <div className="table-data">
                    <div className="table-cell">Document Type</div>
                    <div className="table-cell">Sent Date Time</div>
                    <div className="table-cell">Description</div>
                    <div className="table-cell">Status</div>
                </div>
            </li>

            {props.items.map(item => {
                return (
                    <li key={item.id} className="table-row clickable" onClick={p => props.onDetail(item)}>
                        <div className="table-data">
                            <div className="table-cell" data-title="Document Type : ">{item.attestationType}</div>
                            <div className="table-cell" data-title="Sent Date Time : ">{item.sentTimestamp}</div>
                            <div className="table-cell" data-title="Description : ">{item.description}</div>
                            <div className="table-cell" data-title="Status : ">
                                <AttestationStatusComp status={item.status}>{item.statusLabel}</AttestationStatusComp>
                            </div>
                        </div>
                        
                    </li>
                )
            })
            }
        </ul>
    );
};

export default AttestationListComp;